import { Component } from '@angular/core';
import { AutocompleteComponent } from 'common';
import { EntityService } from '../entity.service';
import { EMPTY, Observable } from 'rxjs';
import { EntityHintData } from '../entity.model';

@Component({
    selector: 'ifb-entity-number-input',
    templateUrl: '../../../../../common/src/lib/ui/autocomplete/autocomplete.component.html',
    styleUrls: ['../../../../../common/src/lib/ui/autocomplete/autocomplete.component.css'],
    standalone: false
})
export class EntityNumberInputComponent extends AutocompleteComponent {

    constructor(private entityService: EntityService) {
        super();
    }
    mel = null;
    label = 'Entity number';

    optionFilter: (input: string | EntityHintData) => Observable<any[]> =
        input => input
            ? this.entityService.queryHints({
                number: !!input ? (typeof input !== 'string' ? input.number : input) : null,
                sortField: 'number',
            })
            : EMPTY;

    optionLabelKey = 'number';
}
